module.exports = __webpack_public_path__ + "img/notification.07925e57.png";